import { styled } from "../../stitches.config";

export type HiddenSizeType = "sm" | "md" | "lg" | "xl";

export const Box = styled("div", {
  variants: {
    hiddenUp: {
      xs: {
        "@xs": {
          display: "none",
        },
      },
      sm: {
        "@sm": {
          display: "none",
        },
      },
      md: {
        "@md": {
          display: "none",
        },
      },
      lg: {
        "@lg": {
          display: "none",
        },
      },
      xl: {
        "@xl": {
          display: "none",
        },
      },
    },
    hiddenDown: {
      xs: {
        "@xsRev": {
          display: "none",
        },
        "@xsMax": {
          display: "none",
        },
      },
      sm: {
        "@smRev": {
          display: "none",
        },
        "@smMax": {
          display: "none",
        },
      },
      md: {
        "@mdRev": {
          display: "none",
        },
        "@mdMax": {
          display: "none",
        },
      },
      lg: {
        "@lgRev": {
          display: "none",
        },
        "@lgMax": {
          display: "none",
        },
      },
      xl: {
        "@xlRev": {
          display: "none",
        },
        "@xlMax": {
          display: "none",
        },
      },
    },
  },
});

export const FlexBox = styled(Box, {
  display: "flex",
});

export const GridBox = styled(Box, {
  display: "grid",
});

export const Inline = styled(Box, {
  display: "inline",
});
